// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1XAhb4HvAzuktu {\n  background: #FFFFFF;\n  border: 1px solid #DFE1E6;\n  border-radius: 3px;\n  padding: 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": "_1XAhb4HvAzuktu"
};
export default ___CSS_LOADER_EXPORT___;
